<template>
  <van-popup
    v-model="popupVisible"
    position="bottom"
    round
    closeable
    :style="{ height: '88%' }"
    class="aigc-media-popup"
    @closed="onClosed"
  >
    <div class="aigc-media-dialog">
      <div class="aigc-media-header">
        <span class="aigc-media-title">选择媒资</span>
      </div>

      <div class="aigc-media-toolbar">
        <van-button
          class="aigc-media-upload-btn"
          size="small"
          type="info"
          color="#5B7FFF"
          :disabled="uploadDisabled"
          @click="triggerUpload"
        >
          {{ uploadLabel }}
        </van-button>
        <input
          ref="fileInput"
          type="file"
          :accept="uploadAccept"
          multiple
          style="display: none"
          @change="onFileInputChange"
        />
      </div>

      <van-tabs v-model="activeTab" color="#5B7FFF" title-active-color="#5B7FFF" @change="onTabChange">
        <van-tab title="我的收藏" name="favorites">
          <div class="aigc-media-tab">
            <van-search
              v-model="favoriteKeyword"
              class="aigc-media-search"
              placeholder="搜索"
              shape="round"
              @search="onFavoriteSearch"
            />
            <div class="aigc-media-list-wrap">
              <van-loading v-if="favoritesLoading" class="aigc-media-loading">加载中...</van-loading>
              <div v-else-if="favorites.length" class="aigc-media-grid">
                <div
                  v-for="it in favorites"
                  :key="'f-' + (it.id != null ? it.id : it.cover)"
                  class="aigc-media-item"
                  :class="{ 'is-selected': isSelected(it, 'fav') }"
                  @click="toggleSelect(it, 'fav')"
                >
                  <div v-if="it.cover" class="aigc-media-item-thumb">
                    <van-image fit="contain" :src="it.cover" />
                  </div>
                  <div v-else class="aigc-media-item-empty">暂无图</div>
                  <van-icon
                    v-if="isSelected(it, 'fav')"
                    name="success"
                    class="aigc-media-item-check"
                    color="#5B7FFF"
                  />
                </div>
              </div>
              <van-empty v-else description="暂无收藏" />
              <van-pagination
                v-if="pager.favorites.total > pageSize"
                v-model="favoritesPage"
                :total-items="pager.favorites.total"
                :items-per-page="pageSize"
                mode="simple"
                class="aigc-media-pager"
                @change="onFavoritesPageChange"
              />
            </div>
          </div>
        </van-tab>

        <van-tab title="我的上传" name="uploads">
          <div class="aigc-media-tab">
            <van-search
              v-model="uploadKeyword"
              class="aigc-media-search"
              placeholder="搜索"
              shape="round"
              @search="onUploadSearch"
            />
            <div class="aigc-media-list-wrap">
              <van-loading v-if="uploadsLoading" class="aigc-media-loading">加载中...</van-loading>
              <div v-else-if="uploads.length" class="aigc-media-grid">
                <div
                  v-for="it in uploads"
                  :key="'u-' + it.id"
                  class="aigc-media-item"
                  :class="{
                    'is-selected': isSelected(it, 'upload'),
                    'is-disabled': isUploadRowDisabled(it),
                  }"
                  @click="!isUploadRowDisabled(it) && toggleSelect(it, 'upload')"
                >
                  <template v-if="it.kind === 'audio'">
                    <div class="aigc-media-item-audio">
                      <van-icon name="music-o" size="28" color="#5B7FFF" />
                    </div>
                  </template>
                  <template v-else-if="it.kind === 'video'">
                    <div v-if="it.cover" class="aigc-media-item-thumb">
                      <van-image fit="contain" :src="it.cover" />
                    </div>
                    <div v-else class="aigc-media-item-video">
                      <van-icon name="video-o" size="28" color="#5B7FFF" />
                    </div>
                  </template>
                  <template v-else>
                    <div v-if="it.cover" class="aigc-media-item-thumb">
                      <van-image fit="contain" :src="it.cover" />
                    </div>
                    <div v-else class="aigc-media-item-empty">暂无图</div>
                  </template>
                  <van-icon
                    v-if="isSelected(it, 'upload')"
                    name="success"
                    class="aigc-media-item-check"
                    color="#5B7FFF"
                  />
                </div>
              </div>
              <van-empty v-else description="暂无上传" />
              <van-pagination
                v-if="pager.uploads.total > pageSize"
                v-model="uploadsPage"
                :total-items="pager.uploads.total"
                :items-per-page="pageSize"
                mode="simple"
                class="aigc-media-pager"
                @change="onUploadsPageChange"
              />
            </div>
          </div>
        </van-tab>

        <van-tab v-if="showVolcanoTabs" title="虚拟人像" name="volcano">
          <div class="aigc-media-tab">
            <van-search
              v-model="volcanoKeyword"
              class="aigc-media-search"
              placeholder="搜索"
              shape="round"
              @search="onVolcanoSearch"
            />
            <div class="aigc-media-list-wrap">
              <van-loading v-if="volcanoLoading" class="aigc-media-loading">加载中...</van-loading>
              <div v-else-if="volcanoGallery.length" class="aigc-media-grid">
                <div
                  v-for="it in volcanoGallery"
                  :key="'v-' + it.id"
                  class="aigc-media-item"
                  :class="{ 'is-selected': isSelected(it, 'volcano') }"
                  @click="toggleSelect(it, 'volcano')"
                >
                  <div v-if="it.cover" class="aigc-media-item-thumb">
                    <van-image fit="contain" :src="it.cover" />
                  </div>
                  <div v-else class="aigc-media-item-empty">暂无图</div>
                  <van-icon
                    v-if="isSelected(it, 'volcano')"
                    name="success"
                    class="aigc-media-item-check"
                    color="#5B7FFF"
                  />
                </div>
              </div>
              <van-empty v-else description="暂无人像素材" />
              <van-pagination
                v-if="pager.volcano.total > pageSize"
                v-model="volcanoPage"
                :total-items="pager.volcano.total"
                :items-per-page="pageSize"
                mode="simple"
                class="aigc-media-pager"
                @change="onVolcanoPageChange"
              />
            </div>
          </div>
        </van-tab>

        <van-tab v-if="showVolcanoTabs" title="授权真人" name="volcano_real">
          <div class="aigc-media-tab">
            <van-search
              v-model="volcanoRealKeyword"
              class="aigc-media-search"
              placeholder="搜索"
              shape="round"
              @search="onVolcanoRealSearch"
            />
            <div class="aigc-media-list-wrap">
              <van-loading v-if="volcanoRealLoading" class="aigc-media-loading">加载中...</van-loading>
              <div v-else-if="volcanoRealGallery.length" class="aigc-media-grid">
                <div
                  v-for="it in volcanoRealGallery"
                  :key="'vr-' + it.id"
                  class="aigc-media-item"
                  :class="{ 'is-selected': isSelected(it, 'volcano_real') }"
                  @click="toggleSelect(it, 'volcano_real')"
                >
                  <div v-if="it.cover" class="aigc-media-item-thumb">
                    <van-image fit="contain" :src="it.cover" />
                  </div>
                  <div v-else class="aigc-media-item-empty">暂无图</div>
                  <van-icon
                    v-if="isSelected(it, 'volcano_real')"
                    name="success"
                    class="aigc-media-item-check"
                    color="#5B7FFF"
                  />
                </div>
              </div>
              <van-empty v-else description="暂无人像素材" />
              <van-pagination
                v-if="pager.volcano_real.total > pageSize"
                v-model="volcanoRealPage"
                :total-items="pager.volcano_real.total"
                :items-per-page="pageSize"
                mode="simple"
                class="aigc-media-pager"
                @change="onVolcanoRealPageChange"
              />
            </div>
          </div>
        </van-tab>
      </van-tabs>

      <div class="aigc-media-footer">
        <span class="aigc-media-footer-count">已选择 {{ selected.length }} / {{ selectableCount }}</span>
        <div class="aigc-media-footer-btns">
          <van-button size="small" @click="popupVisible = false">取消</van-button>
          <van-button
            size="small"
            type="info"
            color="#5B7FFF"
            :disabled="selected.length === 0"
            @click="onConfirm"
          >
            确定
          </van-button>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { getLmBaseURL, normalizeLmMediaDisplayUrl } from "./aigcCreateHelpers";

export default {
  name: "AigcMediaSelectDialog",
  props: {
    value: { type: Boolean, default: false },
    context: { type: String, default: "t2i" },
    selectableCount: { type: Number, default: 1 },
    gallerySelectableCount: { type: Number, default: null },
    uploadLabel: { type: String, default: "上传图片" },
    uploadAccept: { type: String, default: "image/*" },
    uploadDisabled: { type: Boolean, default: false },
    seedanceMixed: { type: Boolean, default: false },
    seedanceRefLimits: {
      type: Object,
      default: () => ({ image: { max: 0 }, video: { max: 0 }, audio: { max: 0 } }),
    },
    seedanceRefCounts: {
      type: Object,
      default: () => ({ image: 0, video: 0, audio: 0 }),
    },
    seedanceRefCountsTotal: { type: Number, default: 0 },
    showVolcanoTabs: { type: Boolean, default: false },
  },
  data() {
    return {
      activeTab: "favorites",
      selected: [],
      favorites: [],
      uploads: [],
      volcanoGallery: [],
      volcanoRealGallery: [],
      favoritesLoading: false,
      uploadsLoading: false,
      volcanoLoading: false,
      volcanoRealLoading: false,
      favoriteKeyword: "",
      uploadKeyword: "",
      volcanoKeyword: "",
      volcanoRealKeyword: "",
      pageSize: 12,
      pager: {
        favorites: { pageNo: 0, total: 0 },
        uploads: { pageNo: 0, total: 0 },
        volcano: { pageNo: 0, total: 0 },
        volcano_real: { pageNo: 0, total: 0 },
      },
      favoritesPage: 1,
      uploadsPage: 1,
      volcanoPage: 1,
      volcanoRealPage: 1,
    };
  },
  computed: {
    popupVisible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
    galleryCap() {
      const g = this.gallerySelectableCount;
      return g != null && g >= 0 ? g : this.selectableCount;
    },
  },
  watch: {
    value(val) {
      if (val) this.onOpen();
    },
    showVolcanoTabs(val) {
      if (!val && (this.activeTab === "volcano" || this.activeTab === "volcano_real")) {
        this.activeTab = "favorites";
      }
    },
  },
  methods: {
    getLmBaseURL,
    parseListTotal(d, fallbackLen) {
      const raw =
        d && d.total != null
          ? d.total
          : d && d.total_count != null
            ? d.total_count
            : d && d.count != null
              ? d.count
              : d && d.totalCount != null
                ? d.totalCount
                : null;
      if (raw != null && raw !== "") {
        const n = Number(raw);
        if (Number.isFinite(n) && n >= 0) return n;
      }
      return Number(fallbackLen) || 0;
    },
    onOpen() {
      this.selected = [];
      this.pager.favorites.pageNo = 0;
      this.pager.uploads.pageNo = 0;
      this.favoritesPage = 1;
      this.uploadsPage = 1;
      this.fetchFavorites();
    },
    onClosed() {
      this.selected = [];
    },
    onTabChange(name) {
      if (name === "favorites") this.fetchFavorites();
      else if (name === "uploads") this.fetchUploads();
      else if (name === "volcano") this.fetchVolcanoGallery();
      else if (name === "volcano_real") this.fetchVolcanoRealGallery();
    },
    onFavoriteSearch() {
      this.pager.favorites.pageNo = 0;
      this.favoritesPage = 1;
      this.fetchFavorites();
    },
    onUploadSearch() {
      this.pager.uploads.pageNo = 0;
      this.uploadsPage = 1;
      this.fetchUploads();
    },
    onVolcanoSearch() {
      this.pager.volcano.pageNo = 0;
      this.volcanoPage = 1;
      this.fetchVolcanoGallery();
    },
    onVolcanoRealSearch() {
      this.pager.volcano_real.pageNo = 0;
      this.volcanoRealPage = 1;
      this.fetchVolcanoRealGallery();
    },
    onFavoritesPageChange(page) {
      this.pager.favorites.pageNo = Math.max(0, page - 1);
      this.fetchFavorites();
    },
    onUploadsPageChange(page) {
      this.pager.uploads.pageNo = Math.max(0, page - 1);
      this.fetchUploads();
    },
    onVolcanoPageChange(page) {
      this.pager.volcano.pageNo = Math.max(0, page - 1);
      this.fetchVolcanoGallery();
    },
    onVolcanoRealPageChange(page) {
      this.pager.volcano_real.pageNo = Math.max(0, page - 1);
      this.fetchVolcanoRealGallery();
    },
    triggerUpload() {
      if (this.uploadDisabled) return;
      this.$refs.fileInput && this.$refs.fileInput.click();
    },
    onFileInputChange(e) {
      const files = Array.from((e && e.target && e.target.files) || []);
      if (e && e.target) e.target.value = "";
      if (!files.length) return;
      this.popupVisible = false;
      this.$emit("upload", files);
    },
    getSelectKey(it, type) {
      const row = it && typeof it === "object" ? it : {};
      const id = row.id != null && String(row.id).trim() !== "" ? String(row.id).trim() : "";
      const mediaUrl =
        row.media_url != null && String(row.media_url).trim() !== ""
          ? String(row.media_url).trim()
          : row.cover != null && String(row.cover).trim() !== ""
            ? String(row.cover).trim()
            : "";
      return `${type}::${id || mediaUrl}`;
    },
    isSelected(it, type) {
      const key = this.getSelectKey(it, type);
      return this.selected.some((s) => s && s.key === key);
    },
    isUploadRowDisabled(it) {
      const kind = it && it.kind ? String(it.kind) : "image";
      if (this.seedanceMixed && this.context === "v2i") return false;
      return kind !== "image";
    },
    maxSelectForType(type) {
      if (this.context === "v2i_first_frame" || this.context === "v2i_last_frame") {
        return 1;
      }
      if (this.context === "v2i" && this.seedanceMixed) {
        const lim = this.seedanceRefLimits || {};
        const cnt = this.seedanceRefCounts || {};
        const totalMax =
          (lim.image && lim.image.max ? lim.image.max : 0) +
          (lim.video && lim.video.max ? lim.video.max : 0) +
          (lim.audio && lim.audio.max ? lim.audio.max : 0);
        const totalRemain = Math.max(0, totalMax - (this.seedanceRefCountsTotal || 0));
        if (type === "upload") return totalRemain;
        const imageRemain = Math.max(0, ((lim.image && lim.image.max) || 0) - (cnt.image || 0));
        return Math.max(0, Math.min(totalRemain, imageRemain));
      }
      if (type === "volcano" || type === "volcano_real") {
        return this.galleryCap;
      }
      return this.selectableCount;
    },
    toggleSelect(it, type) {
      const mediaUrl = it.media_url || it.url || it.cover || "";
      if (!mediaUrl) return;
      const key = this.getSelectKey(it, type);
      const idx = this.selected.findIndex((s) => s && s.key === key);
      if (idx >= 0) {
        this.selected.splice(idx, 1);
        return;
      }
      const maxSelect = this.maxSelectForType(type);
      if (this.selected.length >= maxSelect) {
        this.$toast(`最多还能选择 ${maxSelect} 个`);
        return;
      }
      const assertRaw = it.asset_id != null ? it.asset_id : it.assert_id;
      const assertId = assertRaw != null && String(assertRaw).trim() !== "" ? String(assertRaw).trim() : "";
      this.selected.push({
        key,
        id: it.id,
        name: it.name,
        cover: mediaUrl,
        kind: it.kind || "image",
        type,
        ...(assertId ? { asset_id: assertId } : {}),
        ...(it.human_gallery === "real" || it.human_gallery === "virtual"
          ? { human_gallery: it.human_gallery }
          : {}),
      });
    },
    onConfirm() {
      if (!this.selected.length) return;
      this.$emit("confirm", this.selected.slice());
      this.popupVisible = false;
    },
    async fetchFavorites() {
      const p = this.pager.favorites;
      this.favoritesLoading = true;
      try {
        const params = { page_no: p.pageNo, page_size: this.pageSize };
        const kw = (this.favoriteKeyword || "").trim();
        if (kw) params.keyword = kw;
        const resp = await this.Axios({
          baseURL: getLmBaseURL(),
          url: "/user/fav/",
          method: "get",
          params,
        });
        const body = (resp && resp.data) || {};
        if (body.status === 1 || body.code === 1) {
          const d = body.data || {};
          const listRaw = d.items || d.list || d.results || d.favs || d.favorites || (Array.isArray(d) ? d : []);
          const list = Array.isArray(listRaw) ? listRaw : [];
          p.total = this.parseListTotal(d, list.length);
          const base = getLmBaseURL();
          this.favorites = list
            .map((x, idx) => {
              const raw = x.url || x.image || x.image_url || x.media_url || x.cover || "";
              const abs = raw ? normalizeLmMediaDisplayUrl(raw, base) : "";
              return {
                id: x.id != null ? x.id : x.fav_id != null ? x.fav_id : `fav-${idx}`,
                name: x.name || x.title || "收藏图片",
                cover: abs,
                media_url: abs,
                kind: "image",
              };
            })
            .filter((x) => x.cover);
          return;
        }
        this.favorites = [];
        p.total = 0;
      } catch (e) {
        this.favorites = [];
        p.total = 0;
      } finally {
        this.favoritesLoading = false;
      }
    },
    async fetchUploads() {
      const p = this.pager.uploads;
      this.uploadsLoading = true;
      try {
        const params = { page_no: p.pageNo, page_size: this.pageSize };
        const kw = (this.uploadKeyword || "").trim();
        if (kw) params.keyword = kw;
        const guessKind = (url, mimeOrType) => {
          const t = (mimeOrType || "").toString().toLowerCase();
          if (t.indexOf("video") >= 0) return "video";
          if (t.indexOf("audio") >= 0) return "audio";
          if (t.indexOf("image") >= 0) return "image";
          const u = (url || "").toString().toLowerCase();
          if (/\.(mp4|webm|mov|m4v|avi)(\?|#|$)/.test(u)) return "video";
          if (/\.(mp3|wav|aac|m4a|flac|ogg)(\?|#|$)/.test(u)) return "audio";
          return "image";
        };
        const resp = await this.Axios({
          baseURL: getLmBaseURL(),
          url: "/playlet/assets/uploads/",
          method: "get",
          params,
        });
        const body = (resp && resp.data) || {};
        if (body.status === 1) {
          const d = body.data || {};
          const list = d.items || d.list || d.results || [];
          p.total = this.parseListTotal(d, list.length);
          const base = getLmBaseURL();
          this.uploads = (Array.isArray(list) ? list : [])
            .map((x) => {
              const media_url =
                x.remote_url || x.media_url || x.url || x.file_url || x.download_url || "";
              const kind = guessKind(media_url, x.content_type || x.mime || x.type || x.media_type);
              const coverRaw =
                x.cover ||
                x.thumb ||
                x.thumbnail ||
                x.thumbnail_url ||
                x.first_frame_url ||
                x.poster ||
                (kind === "image" ? media_url : "");
              const cover = coverRaw ? normalizeLmMediaDisplayUrl(coverRaw, base) : "";
              const absUrl = media_url ? normalizeLmMediaDisplayUrl(media_url, base) : "";
              const assertRaw = x.asset_id != null ? x.asset_id : x.assert_id;
              const assertId =
                assertRaw != null && String(assertRaw).trim() !== "" ? String(assertRaw).trim() : "";
              return {
                id: x.id,
                name: x.name || x.title || x.file_name || x.filename,
                kind,
                cover: cover || absUrl,
                media_url: absUrl,
                ...(assertId ? { asset_id: assertId } : {}),
              };
            })
            .filter((x) => x.id != null && x.media_url);
          return;
        }
        this.uploads = [];
        p.total = 0;
      } catch (e) {
        this.uploads = [];
        p.total = 0;
      } finally {
        this.uploadsLoading = false;
      }
    },
    async fetchVolcanoGallery() {
      if (!this.showVolcanoTabs) return;
      const p = this.pager.volcano;
      this.volcanoLoading = true;
      try {
        const params = { page_no: p.pageNo, page_size: this.pageSize };
        const kw = (this.volcanoKeyword || "").trim();
        if (kw) params.keyword = kw;
        const resp = await this.Axios({
          baseURL: getLmBaseURL(),
          url: "/playlet/virtual_human_gallery/",
          method: "get",
          params,
        });
        const body = (resp && resp.data) || {};
        if (body.status === 1) {
          const d = body.data || {};
          const rawList = Array.isArray(d.items) ? d.items : [];
          p.total = this.parseListTotal(d, rawList.length);
          const base = getLmBaseURL();
          this.volcanoGallery = rawList
            .filter((x) => x && x.id != null && x.image_url)
            .map((x) => {
              const abs = normalizeLmMediaDisplayUrl(x.image_url, base);
              return {
                id: x.id,
                asset_id: x.asset_id != null ? x.asset_id : x.assert_id,
                name: (x.title && String(x.title).trim()) || "虚拟人像",
                cover: abs,
                media_url: abs,
                kind: "image",
                human_gallery: "virtual",
              };
            });
          return;
        }
        this.volcanoGallery = [];
        p.total = 0;
      } catch (e) {
        this.volcanoGallery = [];
        p.total = 0;
      } finally {
        this.volcanoLoading = false;
      }
    },
    async fetchVolcanoRealGallery() {
      if (!this.showVolcanoTabs) return;
      const p = this.pager.volcano_real;
      this.volcanoRealLoading = true;
      try {
        const params = { page_no: p.pageNo, page_size: this.pageSize };
        const kw = (this.volcanoRealKeyword || "").trim();
        if (kw) params.keyword = kw;
        const resp = await this.Axios({
          baseURL: getLmBaseURL(),
          url: "/playlet/real_human_gallery/",
          method: "get",
          params,
        });
        const body = (resp && resp.data) || {};
        if (body.status === 1) {
          const d = body.data || {};
          const rawList = Array.isArray(d.items) ? d.items : [];
          p.total = this.parseListTotal(d, rawList.length);
          const base = getLmBaseURL();
          this.volcanoRealGallery = rawList
            .filter((x) => x && x.id != null && x.image_url)
            .map((x) => {
              const abs = normalizeLmMediaDisplayUrl(x.image_url, base);
              return {
                id: x.id,
                asset_id: x.asset_id != null ? x.asset_id : x.assert_id,
                name: (x.title && String(x.title).trim()) || "授权真人",
                cover: abs,
                media_url: abs,
                kind: "image",
                human_gallery: "real",
              };
            });
          return;
        }
        this.volcanoRealGallery = [];
        p.total = 0;
      } catch (e) {
        this.volcanoRealGallery = [];
        p.total = 0;
      } finally {
        this.volcanoRealLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.aigc-media-dialog {
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
}

.aigc-media-header {
  padding: 14px 16px 8px;
  text-align: center;
}

.aigc-media-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.aigc-media-toolbar {
  padding: 0 12px 8px;
}

.aigc-media-upload-btn {
  color: #fff !important;
}

.aigc-media-upload-btn >>> .van-button__text {
  color: #fff;
}

.aigc-media-search.van-search {
  padding: 4px 12px;
}

.aigc-media-search >>> .van-search__content {
  display: flex;
  align-items: center;
  height: 32px;
  min-height: 32px;
  max-height: 32px;
  padding-left: 10px;
  box-sizing: border-box;
}

.aigc-media-search >>> .van-cell {
  flex: 1;
  display: flex;
  align-items: center;
  min-height: 0;
  height: 100%;
  padding: 0 8px 0 0;
  line-height: 20px;
  font-size: 14px;
  background: transparent;
}

.aigc-media-search >>> .van-cell__left-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  height: 16px;
  margin-right: 4px;
  line-height: 1;
}

.aigc-media-search >>> .van-cell__left-icon .van-icon {
  font-size: 14px;
  line-height: 1;
}

.aigc-media-search >>> .van-cell__value,
.aigc-media-search >>> .van-cell__value--alone,
.aigc-media-search >>> .van-field__value {
  min-height: 0;
  height: auto;
}

.aigc-media-search >>> .van-field__body {
  display: flex;
  align-items: center;
  min-height: 0;
}

.aigc-media-search >>> .van-field__control {
  height: 20px;
  line-height: 20px;
  min-height: 0;
  padding: 0;
}

.aigc-media-dialog >>> .van-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.aigc-media-dialog >>> .van-tabs__content {
  flex: 1;
  min-height: 0;
}

.aigc-media-tab {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.aigc-media-list-wrap {
  flex: 1;
  overflow-y: auto;
  padding: 0 12px 8px;
  min-height: 200px;
}

.aigc-media-loading {
  display: flex;
  justify-content: center;
  padding: 32px 0;
}

.aigc-media-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.aigc-media-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 72px;
  padding: 6px 4px;
  border-radius: 8px;
  overflow: hidden;
  background: #f5f7fa;
  border: 2px solid transparent;
  box-sizing: border-box;
}

.aigc-media-item-thumb {
  width: 100%;
  max-height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.aigc-media-item-thumb >>> .van-image {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  max-height: 96px;
}

.aigc-media-item-thumb >>> .van-image__img {
  display: block;
  max-width: 100%;
  max-height: 96px;
  width: auto !important;
  height: auto !important;
  object-fit: contain !important;
}

.aigc-media-item.is-selected {
  border-color: #5b7fff;
}

.aigc-media-item.is-disabled {
  opacity: 0.45;
  pointer-events: none;
}

.aigc-media-item-check {
  position: absolute;
  top: 4px;
  right: 4px;
  background: #fff;
  border-radius: 50%;
  padding: 2px;
}

.aigc-media-item-empty,
.aigc-media-item-audio,
.aigc-media-item-video {
  width: 100%;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #909399;
  background: #eef2ff;
}

.aigc-media-pager {
  margin-top: 12px;
}

.aigc-media-footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px calc(10px + env(safe-area-inset-bottom));
  border-top: 1px solid #ebeef5;
  background: #fff;
}

.aigc-media-footer-count {
  font-size: 13px;
  color: #606266;
  flex: 1;
  min-width: 0;
}

.aigc-media-footer-btns {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/aigc/AigcMediaSelectDialog.vue